import { useMutationWithResultNotification } from '../useMutationWithResultNotification';
import { removeAssetThumbnail } from '../../assets';
import {
  displayErrorArrayNotifications,
  displaySuccessNotification,
} from '../../../modules/Notifications';
import { IMutationRequest } from '../../../interfaces/request';
import { OrganizationQueryParams } from '../../../interfaces/queryParams';

const useRemoveAssetThumbnail = ({
  params,
  options,
}: IMutationRequest<OrganizationQueryParams>) => {
  return useMutationWithResultNotification({
    asyncApiFunction: async (assetId: string) => {
      await removeAssetThumbnail(params.organizationId, assetId);
    },
    resetOnResult: true,
    onErrorArray: (errorArray) => {
      displayErrorArrayNotifications(
        errorArray,
        'Api.Mutations.Assets.RemoveAssetThumbnail.failure'
      );
      options.errorFb?.();
    },
    onSuccess: () => {
      displaySuccessNotification(
        'Api.Mutations.Assets.RemoveAssetThumbnail.success'
      );
      options.successFb?.();
    },
  });
};

export default useRemoveAssetThumbnail;
